import { render } from "./ExtSeminar.vue?vue&type=template&id=8c15bad0&ts=true"
import script from "./ExtSeminar.vue?vue&type=script&lang=ts"
export * from "./ExtSeminar.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/shunta/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__